/* @flow */

import React from 'react';
import { Button } from 'dibs-elements/exports/Button';
import formStyles from '../styles/FormGeneral.scss';
import classnames from 'classnames';

type Props = {|
    buttonName: Element,
    onClick: () => void,
    classNames?: string,
|};

export const MatchmakerButton = ({ buttonName, classNames, onClick }: Props) => {
    return (
        <div className={classnames(classNames, formStyles.ctaButton)}>
            <Button onClick={onClick} dataTn="matchmaker-formSubmit" size="large" fullWidth>
                {buttonName}
            </Button>
        </div>
    );
};
